import React from "react";
import PageShell from "../common/page_shell";
import Skills from "../inner/skills/skills";
import data from "../data/biodata.json";

const SkillsPage = () => {
  return (
    <PageShell>
      <Skills allskills={data?.details?.all_skills || []} />
    </PageShell>
  );
};

export default SkillsPage;
